import type { AssetTechnicalTabProps } from "./asset-technical-tab.type";

import { AssetTechnicalUpdate } from "@/modules/asset/asset-technical-update";

const AssetTechnicalTab = ({ asset }: AssetTechnicalTabProps) => {
  return <AssetTechnicalUpdate asset={asset} />;
};

export default AssetTechnicalTab;
